import {
  createRouter,
  createWebHistory,
  createWebHashHistory,
} from 'vue-router';
import useUserStore from '@/store/modules/user';
import CONSTANTS from '@/utils/constants';
import util from '@/utils';

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/layout'),
    async beforeEnter(to, from, next) {
      const token = util.getLocalStorage(CONSTANTS.TOKEN);
      if (token) {
        const userStore = useUserStore();
        if (userStore.menus.length) {
          if (to.fullPath === from.fullPath) {
            next(userStore.menus[0].path);
          } else {
            next();
          }
        } else {
          await userStore.getUserInfo();
          next(userStore.menus[0].path);
        }
      } else {
        next('/login');
      }
    },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/pages/login'),
  },
  {
    path: '/:pathMatch(.*)*',
    component: () => import('@/pages/loading'),
    hidden: true,
    async beforeEnter(to, from, next) {
      const token = util.getLocalStorage(CONSTANTS.TOKEN);
      if (token) {
        const userStore = useUserStore();
        if (userStore.menus.length) {
          next(userStore.menus[0].path);
        } else {
          await userStore.getUserInfo();
          if (userStore.menus.length) {
            if (from.path === to.path) {
              next(userStore.menus[0].path);
            } else {
              next(to.fullPath);
            }
          } else {
            userStore.clearStorage();
            next('/login');
          }
        }
      } else {
        next('/login');
      }
    },
  },
  {
    path: '/404',
    name: '404',
    component: () => import('@/pages/404'),
    hidden: true,
  },
];

export const permissionsRouteMap = {
  // 小程序配置
  miniappConfig: {
    name: 'miniappConfig',
    path: '/miniapp/banner',
    icon: 'icon-xiaochengxu',
    meta: { title: '小程序配置' },
    component: () => import('@/pages/miniappConfig'),
    children: [
      {
        name: 'banner',
        path: '/miniappConfig/banner',
        icon: 'icon-zizhanghao',
        meta: { title: '轮播图管理' },
        component: () => import('@/pages/miniappConfig/banner'),
      }, {
        name: 'mappIndex',
        path: '/miniappConfig/mappIndex',
        icon: 'icon-zizhanghao',
        meta: { title: '首页配置' },
        component: () => import('@/pages/miniappConfig/mappIndex'),
      },
      {
        name: 'temple',
        path: '/miniappConfig/temple',
        icon: 'icon-zizhanghao',
        meta: { title: '寺庙管理' },
        component: () => import('@/pages/miniappConfig/temple'),
      },
    ],
  },
  order: {
    name: 'order',
    path: '/order',
    icon: 'icon-dingdanguanli',
    meta: { title: '订单管理' },
    component: () => import('@/pages/order'),
  },
  goods: {
    name: 'goods',
    path: '/goods',
    icon: 'icon-shangpinguanli',
    meta: { title: '商品管理' },
    component: () => import('@/pages/goods'),
  },
  // 捐赠池
  donate: {
    name: 'donate',
    path: '/donate/changeList',
    icon: 'icon-aixinjuanzeng',
    meta: { title: '日行一善' },
    component: () => import('@/pages/donate'),
    children: [
      {
        name: 'donateChangeList',
        path: '/donate/changeList',
        icon: 'icon-zizhanghao',
        meta: { title: '捐赠池变动' },
        component: () => import('@/pages/donate/changeList'),
      },
      {
        name: 'masterVideo',
        path: '/donate/thanks',
        icon: 'icon-zizhanghao',
        meta: { title: '大师视频' },
        component: () => import('@/pages/donate/thanks'),
      },
      // {
      //   name: 'donateConfig',
      //   path: '/donate/config',
      //   meta: { title: '配置' },
      //   component: () => import('@/pages/donate/config'),
      // },
    ],
  },
  recommend: {
    name: 'recommend',
    path: '/recommend',
    icon: 'icon-tuijianren',
    meta: { title: '超管推荐' },
    component: () => import('@/pages/recommend'),

  },
  // 账号管理
  account: {
    // judgeAdmin: true,
    name: 'account',
    path: '/account',
    icon: 'icon-zizhanghaoguanli',
    meta: { title: '子账号管理' },
    component: () => import('@/pages/account'),
  },
};

const router = createRouter({
  history:
    process.env.NODE_ENV === 'production'
      ? createWebHistory()
      : createWebHashHistory(),
  routes: routes,
});

// 动态添加路由
export const addRoutes = permissions => {
  permissions.forEach(key => {
    const route = permissionsRouteMap[key];
    if (route) router.addRoute('home', route);
  });
};

export default router;
